<template>
  <div class="mb-5">
    <h3 class="mb-3">{{ report.title }}</h3>

    <div class="row">
      <div class="col-md-6 col-xl-3 mb-4">
        <div class="card card-widget h-100 pointer" @click="viewRawData('Percentage Complete', report.project_work_remaining_data)">
          <div class="card-body">
            <h3 class="widget-title">Percentage Complete <i class="far fa-external-link-square float-end"></i></h3>
            <p class="lead">{{ report.project_work_completion }}%</p>
            <div class="progress mb-2">
              <div class="progress-bar" :style="{ width: Math.min(report.project_work_completion, 100) + '%' }"></div>
            </div>
            <p class="small text-muted mb-0">{{ report.project_work_remaining }} hrs remaining of {{ report.project_work_estimated }} hrs.</p>
          </div>
        </div>
      </div>

      <div class="col-md-6 col-xl-3 mb-4">
        <div class="card card-widget h-100">
          <div class="card-body">
            <template v-if="isAdmin">
              <h3 class="widget-title">Achieved Hourly Rate</h3>
              <p class="lead" :class="classForHourlyRate(report.acheived_hourly_rate)">${{ report.acheived_hourly_rate }}</p>
            </template>
            <template v-else>
              <h3 class="widget-title">Total Time Spent</h3>
              <p class="lead">{{ report.total_spent }} <small class="text-muted">hrs</small></p>
            </template>
            <p class="small text-muted mb-0">{{ report.total_spent }} hrs of {{ report.total_estimated }} hrs completed.</p>
          </div>
        </div>
      </div>

      <div class="col-md-6 col-xl-3 mb-4">
        <div class="card card-widget h-100 pointer" @click="viewRawData('Estimation Accuracy', report.estimate_v_actual_data)">
          <div class="card-body">
            <h3 class="widget-title">Estimation Accuracy <i class="far fa-external-link-square float-end"></i></h3>
            <p class="lead" :class="classForEstimationAccuracy(report.estimation_accuracy)">{{ report.estimation_accuracy }}%</p>
            <p class="small text-muted mb-0">Estimated {{ report.project_work_estimate_to_date }} hrs, actually taking {{ report.project_work_estimate_spent }} hrs.</p>
          </div>
        </div>
      </div>

      <div class="col-md-6 col-xl-3 mb-4">
        <div class="card card-widget h-100 pointer" @click="viewRawData('Unplanned Time', report.unplanned_data)">
          <div class="card-body">
            <h3 class="widget-title">Unplanned Time <i class="far fa-external-link-square float-end"></i></h3>
            <p class="lead">{{ report.unplanned }} <small class="text-muted">hrs</small></p>
            <p class="small text-muted mb-0">Click for breakdown.</p>
          </div>
        </div>
      </div>

      <template v-if="report.stage == 3">
        <div class="col-md-6 col-xl-3 mb-4">
          <div class="card card-widget h-100">
            <div class="card-body">
              <h3 class="widget-title">Warranty</h3>
              <p class="lead">{{ report.warranty_time_spent }} <small class="text-muted">hrs</small></p>
              <p class="small text-muted mb-0">{{ report.warranty_time_spent }} hrs spent of {{ report.warranty_time_allocated }} hrs.</p>
            </div>
          </div>
        </div>

        <div class="col-md-6 col-xl-4 mb-4">
          <div class="card card-widget h-100">
            <div class="card-body">
              <h3 class="widget-title">Time Breakdown</h3>
              <donut-chart :segments="breakdown" unit="hrs" />
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { user } from 'mixins'
import { mapState } from 'vuex'
import DonutChart from '../charts/DonutChart'

export default {
  mixins: [user],

  components: {
    DonutChart
  },

  props: {
    report: {
      required: true,
      type: Object
    }
  },

  computed: {
    ...mapState('user', ['authorized']),

    breakdown () {
      return [
        { label: 'Project Work', value: this.report.project_work_spent },
        { label: 'Management', value: this.report.management_spent },
        { label: 'Unplanned Changes', value: this.report.unplanned },
        { label: 'Warranty', value: this.report.warranty_time_spent }
      ]
    }
  },

  methods: {
    viewRawData (title, rows) {
      this.$emit('show-data', { title, rows: rows || [] })
    },

    classForHourlyRate (rate) {
      if (rate >= 185) {
        return 'text-success'
      } else if (rate >= 150) {
        return 'text-warning'
      }

      return 'text-danger'
    },

    classForEstimationAccuracy (accuracy) {
      if (accuracy >= 85) {
        return 'text-success'
      } else if (accuracy >= 65) {
        return 'text-warning'
      }

      return 'text-danger'
    }
  }
}
</script>

<style scoped>
.pointer {
  cursor: pointer;
}
</style>
